import { useCallback } from "react";

import { Frame, FrameStencil } from "../../types";
import { PlayStateApi } from "../use-play-state-api";

export type UpdateFrameStencilsCallbackFunc = (frameStencils: FrameStencil[]) => FrameStencil[];
export type UpdateFrameStencilsFunc = (
  frameStencilsCallback: UpdateFrameStencilsCallbackFunc | Frame["frameStencils"],
  skipSave?: boolean
) => void;

export const useUpdateFrameStencils = ({
  updateActiveFrame,
}: Pick<PlayStateApi, "updateActiveFrame">): UpdateFrameStencilsFunc => {
  return useCallback(
    (frameStencilsCallback, skipSave = false) => {
      // frame setState
      updateActiveFrame(
        (prevState) => ({
          ...prevState,
          frameStencils:
            // if frameStencilsCallback is a function..
            frameStencilsCallback instanceof Function
              ? frameStencilsCallback(prevState.frameStencils)
              : // else, return non-function frameStencils
                frameStencilsCallback,
        }),
        skipSave
      );
    },
    [updateActiveFrame]
  );
};

export type UpdateFrameStencils = ReturnType<typeof useUpdateFrameStencils>;
